import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import icons from "components/UI/icons/icons";
import {IAddressTableData, PageType} from "API/types";

interface IModalPaginationProps {
    meta: IAddressTableData,
    setPage: Dispatch<SetStateAction<PageType>>,
}

const ModalPagination: React.FC<IModalPaginationProps> = (
    {
        meta,
        setPage,
    }
) => {
    const {IconChevron} = icons;
    const [currentPage, setCurrentPage] = useState<PageType>(meta.current_page + 1);
    const [currentCountPage, setCurrentCountPage] = useState<PageType>(meta.current_page + 1);

    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage((currentPage - 1) * meta.page_size);
        }

        if (currentCountPage === 1) {
            setCurrentCountPage((currentCountPage - 1) + meta.page_size);
        } else {
            setCurrentCountPage(currentCountPage * meta.page_size);
        }

        if (currentPage === meta.page_count) {
            setCurrentCountPage(meta.total_count);
        }
    }, []);

    return (
        <div className="pagination">
            <p className="pagination__total small">{currentPage}-{currentCountPage} from {meta.total_count}</p>
            <div className="pagination__buttons">
                <button disabled={currentPage === 1} onClick={() => setPage(page => page - 1)} className="pagination__button pagination__button--prev">
                    prev
                    <IconChevron/>
                </button>
                <button disabled={meta.current_page + 1 === meta.page_count} onClick={() => setPage(page => page + 1)} className="pagination__button pagination__button--next">
                    next
                    <IconChevron/>
                </button>
            </div>
        </div>
    );
};

export default ModalPagination;